import axios from "axios";

const userServiceRoot = process.env.REACT_APP_USER_SERVICE;

export interface SystemStatusResponse {
  message: string;
  type: "major" | "partial" | "planned";
}

/**
 * Checks the system status from the user service
 * @returns Promise<SystemStatusResponse | null> - Returns null for 204 (no issues), otherwise returns status data
 */
export async function getSystemStatus(): Promise<SystemStatusResponse | null> {
  try {
    const response = await axios.get(`${userServiceRoot}/system/status`);

    // 204 means no issues
    if (response.status === 204) {
      return null;
    }

    // Any other 2xx response should contain the status data
    return response.data as SystemStatusResponse;
  } catch (error) {
    // If we get a server error, treat it as a system issue
    if (error.response?.status >= 500) {
      return {
        message: "System service unavailable",
        type: "major"
      };
    }

    // For other errors (network, etc.), return null to avoid false alarms
    return null;
  }
}
